(function ($) {

	$(document).ready(function () {

		if ($('.page-clinics-and-centers').length > 0) {

			/* Reset everything and get keywords that can be found within a tab content */
			$('.page-clinics-and-centers .panel').on('load', function (e) {
				// Reset the view
				reset();
				// Get the keywords of all items within the current tab
				getKeywords();
			});

			/**
			 * Bind click function to deepening dropdown
			 * Reset the input field for there isn't any correlation between the input and the dropdown
			 */
			var dropDownItemClick = function () {
				$('.page-clinics-and-centers .nice-select li').each(function () {
					$(this).unbind('click');
					$(this).click(function () {
						currentDeepening = $(this).data('value');
						$inputField.val('');

						if (currentDeepening === 0) {
							reset();
						} else {
							$('.b-search-result').hide();
							$("[data-uid*='|" + currentDeepening + "|']").closest('.b-search-result').show();
							$('h4').not('[data-uid*="|' + currentDeepening + '|"]').closest('.panel').hide();
							$('h4[data-uid*="|' + currentDeepening + '|"]').closest('.panel').show();
						}

					});
				});
			};

			/* Bind click event for the first time */
			dropDownItemClick();

			/* Define the needed variables */
			var $inputField = $('.page-clinics-and-centers input[type="text"]'),
				$searchButton = $('.page-clinics-and-centers .search-form button[type=submit]'),
				$suggestions = $('#clinic-suggestions'),
				currentDeepening = 0,
				currentTabId = 'tab-clinics',
				optionPrepended = false,
				globalKeywords = [];

			/* Input-Field listening */
			$inputField.focus(function (event) {
				searchForKeyword(event);
			}).keyup(function (event) {
				searchForKeyword(event);
			});

			$('.page-clinics-and-centers form').submit(function (event) {
				event.preventDefault();
			});

			$('.page-clinics-and-centers form input').focus(function (event) {
				resetDeepening();
			});

			$searchButton.click(function (event) {
				var input = $inputField.val().toLowerCase();
				if (input) {
					performSearch(input, false);
				}
			});

			/**
			 * Get all keywords for parents and child
			 * Merge those into a sorted array
			 */
			var getKeywords = function () {
				globalKeywords = [];
				$('#sec-1 .heading-area > h4, #sec-2 .heading-area > h4').each(function (index) {
					if ($(this).data('keywords')) {
						var items = $(this).data('keywords').split(',');
						if (items) {
							$.each(items, function (key, keyword) {
								keyword = keyword.trim();
								if (keyword && globalKeywords.indexOf(keyword) === -1) {
									globalKeywords.push(keyword);
								}
							});
						}
					}
					// Also take link titles as keywords
					if ($(this).text() && $(this).text().trim() && !inArray($(this).text().trim(), globalKeywords)) {
						globalKeywords.push($(this).text().trim());
					}
				});
				// Sort globalKeywords alphabetically
				globalKeywords.sort(compareStrings);
			};

			// Get keywords for the first time
			getKeywords();

			/* Look up for keywords that match the user's input */
			var searchForKeyword = function (event) {
				if (event.key == 'Enter') {
					if ($inputField.val().trim) {
						resetDeepening();
						performSearch($inputField.val());
					} else {
						// if (currentDeepening !== 0) {
						reset();
						// }
					}
				} else {
					var items = '';
					var anzahl = 0;
					var eingabe = $inputField.val().toLowerCase();
					if (eingabe.length > 0) {
						if (eingabe.length > 2) {
							for (var i = 0; i < globalKeywords.length; i++) {
								var wort = globalKeywords[i].toLowerCase();
								if (wort.indexOf(eingabe) !== -1) {
									var start = wort.indexOf(eingabe),
										end = start + eingabe.length - 1,
										display = '';
									for (var letterIndex = 0; letterIndex < wort.length; letterIndex++) {
										if (letterIndex === start) {
											display += '<b>';
										}
										display += wort[letterIndex];
										if (letterIndex === end) {
											display += '</b>';
										}
									}
									items += '<li><a href="javascript:void(0)" data-keywords="' + globalKeywords[i] + '">' + display + '</a></li>';
									anzahl++;
								}
							}
							if (anzahl > 0) {
								$suggestions.html(items).show();
								// Stichwort auswählen > Treffer anzeigen, andere ausblenden
								$suggestions.find('a').click(function (event) {

									resetDeepening();
									performSearch($(this).data('keywords'));
								});
							} else {
								$suggestions.html('<li class="no-entries">Leider keine Treffer</li>').show();
							}
						}
					} else {
						$suggestions.hide();
						// if (!currentDeepening) {
						reset();
						// }
					}
				}
			};

			/**
			 * Hide suggestions and perform the search
			 * Show parents if either:
			 * - A parent title contains the searchword
			 * - A parent's keyword matches the searchword
			 * - A Child matches the searchword by title or keywords
			 *
			 * Show child if either:
			 * - A child title contains the searchword
			 * - A child's keyword matches the searchword
			 */
			var performSearch = function (searchWord, isDeepeningSeach) {

				if (isDeepeningSeach) {

					if (!currentDeepening) {
						reset();
					} else {
						// console.log(currentTabId);
						$('#sec-1 .heading-area > h4, #sec-2 .heading-area > h4').each(function () {
							var $parentLink = $(this),
								$parent = $parentLink.parents('section.b-search-result'),
								showParent = false;

							var thisDeepening = '';
							if ($parentLink.data('deepening')) {
								thisDeepening = String($parentLink.data('deepening'));
							}
							if (thisDeepening && thisDeepening.indexOf(currentDeepening) !== -1) {
								showParent = true;
							}

							if (showParent) {
								$parent.show();
							} else {
								$parent.hide();
							}
						});
					}
				} else {
					$inputField.val(searchWord);
					$suggestions.hide();

					if (searchWord) {
						searchWord = searchWord.toLowerCase();
					}

					$('#sec-1 .heading-area > h4, #sec-2 .heading-area > h4').each(function () {
						var $parentLink = $(this),
							$parent = $parentLink.parents('section.b-search-result'),
							showParent = false,
							currentLinkTitle = $parentLink.text(),
							currentKeywords = $parentLink.data('keywords');


						if (currentLinkTitle) {
							currentLinkTitle = currentLinkTitle.trim().toLowerCase();
							if (currentLinkTitle && currentLinkTitle.indexOf(searchWord) !== -1) {
								showParent = true;
							}
						}
						if (currentKeywords) {
							currentKeywords = currentKeywords.trim();
							// No need to check keywords if parent is already supposed to be shown
							if (!showParent && currentKeywords) {
								currentKeywords = currentKeywords.split(',');
								if (currentKeywords) {
									// Trim all array values as well
									$.each(currentKeywords, function (index, keyword) {
										currentKeywords[index] = keyword.toLowerCase().trim();
									});
									if (currentKeywords.indexOf(searchWord) !== -1) {
										showParent = true;
									}
								}
							}
						}

						if (showParent) $parent.show();
						else {

							$parent.find('.heading-area > h4').each(function () {
								var currentChildTitle = $(this).text();
								var showChild = false;
								if (currentChildTitle) {
									currentChildTitle = currentChildTitle.trim().toLowerCase();
									// alert( 'currentChildTitle: ' + currentChildTitle );
									if (currentChildTitle && currentChildTitle.indexOf(searchWord) !== -1) {
										showChild = true;
									} else {
										var currentChildKeywords = $(this).data('keywords');
										if (currentChildKeywords) {
											currentChildKeywords = currentChildKeywords.trim().split(',');
											if (currentChildKeywords) {
												/* Trim all array values as well */
												$.each(currentChildKeywords, function (index, keyword) {
													currentChildKeywords[index] = keyword.toLowerCase().trim();
												});
												if (currentChildKeywords.indexOf(searchWord) !== -1) {
													showChild = true;
												}
											}
										}
									}
								}
								if (showChild) {
									$(this).closest('.panel').show();
									showParent = true;
								} else {
									$(this).closest('.panel').hide();

								}
							});

							if (showParent) {
								$parent.show();
							} else {
								$parent.hide();
							}
						}
					});
				}
			};


			/* Reset and show all elements either by a given tabId or by the current tabId */
			var reset = function (tabId) {
				if (tabId) {
					$('#' + tabId + ' .c-parent > li > a, #' + tabId + ' .c-childs > li > a').show();
				} else {
					$('.b-search-result, .panel').show();

				}
				$inputField.val('');
				$suggestions.hide();
			};

			var resetDeepening = function () {
				currentDeepening = 0;
				$('.page-clinics-and-centers .nice-select span.current').html('Fachgebiet wählen');
			};
		}
	});

})(jQuery);

/**
 * URL Parameter auslesen
 * var allVars = $.getUrlVars();
 * var someVar = $.getUrlVar('someVar');
 */
$.extend({
	getUrlVars: function () {
		var vars = [], hash;
		var location = decodeURIComponent(window.location.href);
		var hashes = location.slice(window.location.href.indexOf('?') + 1).split('&');

		for (var i = 0; i < hashes.length; i++) {
			hash = hashes[i].split('=');
			vars.push(hash[0]);
			vars[hash[0]] = hash[1];
		}
		return vars;
	},
	getUrlVar: function (name) {
		return $.getUrlVars()[name];
	}
});

/**
 * Check if needle is in haystack but do not respect case-sensitivity
 * @param needle
 * @param haystack
 */
function inArray(needle, haystack) {
	var isInArray = false;
	needle = needle.toLowerCase();
	$.each(haystack, function (index, value) {
		if (value.toLowerCase() === needle) {
			isInArray = true;
			return true;
		}
	});
	return isInArray;
}

/* Umlaute richtig sortieren */
function compareStrings(a, b) {
	a = a.toLowerCase();
	a = a.replace("ä", "ae");
	a = a.replace("ö", "oe");
	a = a.replace("ü", "ue");
	a = a.replace("ß", "ss");

	b = b.toLowerCase();
	b = b.replace("ä", "ae");
	b = b.replace("ö", "oe");
	b = b.replace("ü", "ue");
	b = b.replace("ß", "ss");

	return (a == b) ? 0 : (a > b) ? 1 : -1;
}
